// La page d'un événement (js/react/ecrans/Evenement.jsx).
import { vueReact } from "../react/pont.jsx";
import Evenement from "../react/ecrans/Evenement.jsx";

export const rendre = vueReact(Evenement);
